import React from "react";
import Spinner from "../Spinner";
import { classNames } from "../../../utils/classNames";
const Button = (props: any) => {
  const { type = "submit", label, isLoading = false, disabled = false, ...other } = props;
  return (
    <>
      <button
        type={type}
        disabled={isLoading || disabled}
        className={classNames(isLoading || disabled ? "bg-gray-500" : "bg-primary", "w-full text-white py-2 rounded my-2")}
        {...other}
      >
        {isLoading ? <Spinner /> : label}
      </button>
    </>
  );
};

export default Button;
